import { useRef } from 'react';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import useScrollMotion from '@/hooks/useScrollMotion';
import HeroShowreel from './components/HeroShowreel';
import About from './components/About';
import Work from './components/Work';
import Expertise from './components/Expertise';
import Approach from './components/Approach';
import People from './components/People';
import Finale from './components/Finale';

export default function Home() {
  const root = useRef<HTMLElement>(null);
  useScrollMotion(root);

  return (
    <>
      <Header />
      <main ref={root} className="overflow-x-clip">
        <HeroShowreel />
        <About />
        <Work />
        <Expertise />
        <Approach />
        <People />
        <Finale />
      </main>
      <Footer />
    </>
  );
}